import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    treatmentNotes: [],
    treatmentNote: null,
    // treatmentNotes: [],
    // treatmentNote: null,
};

const getters = {
    getAllTreatmentNotes: (state) => state.treatmentNotes,
    getSingleTreatmentNote: (state) => state.treatmentNote,
};

const mutations = {


}

const actions = {


    async editTreatmentNote({ commit }, form) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation editTreatmentNote($id: Int!, $input: TreatmentNoteInput!) {
                        editTreatmentNote(id: $id, treatmentNoteInput: $input) {
                            id
                            
                        }
                    }
                `,
                variables: {
                    id: form.id,
                    input: {
                        name: form.name,
                        departmentId: form.departmentId,
                        title: form.title,
                        showAddress: form.showAddress,
                        showDateOfBirth: form.showDateOfBirth,
                        showMedicalNumber: form.showMedicalNumber,
                        showReferenceNumber: form.showReferenceNumber,
                        showOccupation: form.showOccupation,
                        formJsonQuestion: form.formJsonQuestion,
                        stamp: form.stamp,
                        isPublic: form.isPublic,
                        publishOnly: form.publishOnly,
                        showDoctor: form.showDoctor,
                        showCaseManager: form.showCaseManager,
                        showMedicalDirector: form.showMedicalDirector
                    }
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    }
                }
            });
        } catch (error) {
            return false;
        }

        return true;
    },
    async createTreatmentNote({ commit }, form) {
        console.log(form)
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation createTreatmentNote($form: TreatmentNoteInput!) {
                        createTreatmentNote(treatmentNoteInput: $form) { 
                            id
                        }
                    }
                `,
                variables: {
                    form: form
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    }
                }
            });
        } catch (e) {
            console.log("Error", e.stack);
            console.log("Error", e.name);
            console.log("Error", e.message);
            return false;
        }

        return true;
    },
    async createPatientTreatmentNote({ commit }, form) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation createPatientTreatmentNote($form: PatientTreatmentNoteInput!) {
                        createPatientTreatmentNote(patientTreatmentNoteInput: $form) {
                            id
                        }
                    }
                `,
                variables: {
                    form: form
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    }
                }
            });
            const createdId = response?.data?.createPatientTreatmentNote?.id;
            return createdId != null ? createdId : false;
        } catch (e) {
            return false;
        }
    },
    async editPatientTreatmentNote({ commit }, payload) {

        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation editPatientTreatmentNote($id: Int!,$editPatientTreatmentNote: PatientTreatmentNoteInput!) {
                        editPatientTreatmentNote(id: $id,patientTreatmentNoteInput: $editPatientTreatmentNote) {
                            id
                        }
                    }
                `,
                variables: {
                    id: payload.id,
                    editPatientTreatmentNote: {
                        status: payload.status,
                        formJsonAnswer: payload.formJsonAnswer,
                        attendeesId: payload.attendeesId,

                    }
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    }
                }
            });


            if (response.errors && response.errors.length > 0) {
                return { success: false, message: response.errors[0].message };
            }
        } catch (e) {
            return { success: false, message: e.message || 'Failed to edit treatment note' };
        }



        return { success: true };
    }

}

export default {
    state,
    getters,
    mutations,
    actions,
};

